import moment from "moment";

export const hasVal = (v) =>
  v !== undefined && v !== null && String(v).trim() !== "";

// Tahap persetujuan LKM yang harus terisi semua sebelum dianggap Selesai.
// Harus sama dengan REQUIRED di backend (getListLkm.js).
// Kalau Ka. QC juga wajib, tambahkan "qc" di sini dan di backend.
export const REQUIRED_FIELDS = [
  "penerima",
  "diketahui",
  "verifikasiPenerima",
  "verifikasi",
];

export const isLkmDone = (d) =>
  !!d && REQUIRED_FIELDS.every((f) => hasVal(d[f]));

// Status diturunkan dari data, tanpa flag isDiketahui/isDiterima/isDiVerifikasi
//  - Open               : belum ada penerima
//  - Sedang di Proses   : sudah ada penerima, tapi tahap lain belum lengkap
//                         (diketahui, penerima & pelapor setelah perbaikan)
//  - Selesai            : semua tahap terisi (masuk Done)
export const getLkmStatus = (d) => {
  if (!d) return { key: "open", label: "Open" };
  if (!hasVal(d.penerima)) return { key: "open", label: "Open" };
  if (!isLkmDone(d)) return { key: "proses", label: "Sedang di Proses" };
  return { key: "done", label: "Selesai" };
};

export const formatNoLkm = (d) =>
  `${String(d.lkmNumber ?? "").padStart(3, "0")}/${d.keBagian}/${moment(
    d.createDate
  ).format("YYYY")}`;

export const formatTgl = (date, format = "DD-MM-YY HH:mm") =>
  date ? moment(date).format(format) : "";
